const IconButton = () => {
  return {
    MuiIconButton: {
      styleOverrides: {
        root: {},
      },
    },
  }
}

export default IconButton
